/* =========================================================
   gallery-preload.js — Produktgalerie: Bilder vorladen
   ---------------------------------------------------------
   07.10.2026: Lädt die übrigen Galeriebilder nach dem ersten
   Bild im Hintergrund vor (eins nach dem anderen), damit der
   Klick auf eine Vorschau das Bild sofort zeigt. Beim Überfahren
   oder Antippen einer Vorschau wird diese sofort vorgezogen.
   Wird bei Datensparmodus und sehr langsamer Verbindung
   übersprungen. Ändert nichts an global.js (ProductGallery).
   ========================================================= */
(function () {
  'use strict';

  function init() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length < 2) return;

    var conn = navigator.connection || {};
    if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

    var sizes = main.getAttribute('sizes') || '(min-width: 1024px) 50vw, 100vw';
    var done = [];
    var kept = [];
    var queue = thumbs.slice();
    var running = false;

    function load(thumb, cb) {
      var src = thumb.getAttribute('data-image-src');
      if (!src || done.indexOf(src) !== -1) { if (cb) cb(); return; }
      done.push(src);
      var img = new Image();
      img.decoding = 'async';
      img.sizes = sizes;
      var set = thumb.getAttribute('data-image-srcset');
      if (set) img.srcset = set;
      img.onload = img.onerror = function () { if (cb) cb(); };
      img.src = src;
      kept.push(img);
    }

    function later(fn) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(fn, { timeout: 1500 });
      } else {
        window.setTimeout(fn, 200);
      }
    }

    function step() {
      var thumb = queue.shift();
      if (!thumb) { running = false; return; }
      load(thumb, function () { later(step); });
    }

    function start() {
      if (running) return;
      running = true;
      later(step);
    }

    thumbs.forEach(function (thumb) {
      ['pointerenter', 'touchstart', 'focus'].forEach(function (evt) {
        thumb.addEventListener(evt, function () { load(thumb); }, { passive: true });
      });
    });

    if (main.complete) {
      start();
    } else {
      main.addEventListener('load', start, { once: true });
      window.addEventListener('load', start, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
